import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Get API URL from environment variables
const API_URL = process.env.REACT_APP_BACKEND_API_URL;

// Async action for user registration
export const registerUser = createAsyncThunk(
  "/auth/register",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/auth/register`, userData);
      return response.data; // Returns user object
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async action for user login
export const loginUser = createAsyncThunk(
  "/auth/login",
  async (userData, { rejectWithValue }) => {
    try {
      // console.log("API_URL", API_URL);
      // console.log("backend ", process.env.REACT_APP_BACKEND_API_URL);
      const response = await axios.post(`${API_URL}/auth/login`, userData);
      return response.data; // Returns user object
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Load user and darkMode from localStorage if available
const user = JSON.parse(localStorage.getItem("user"));

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: user || null,
    isAuthenticated: user ? true : false,
    loading: false,
    error: null,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      localStorage.removeItem("user");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.user = action.payload;
        state.isAuthenticated = true;
        state.loading = false;
        localStorage.setItem("user", JSON.stringify(action.payload));
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.user = action.payload;
        state.isAuthenticated = true;
        state.loading = false;
        localStorage.setItem("user", JSON.stringify(action.payload));
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
